import { useState } from "react";

const links = [
  { href: "#company", label: "Company" },
  { href: "#founders", label: "Founders" },
  { href: "#contact", label: "Contact" }
];

export function Navbar() {
  const [expanded, setExpanded] = useState(false);
  const close = () => setExpanded(false);

  // "Contact" both scrolls to the footer and opens the waitlist form there,
  // matching the hero CTA. The href is left intact so the jump still happens
  // natively and the link keeps working without JavaScript.
  const activate = (href: string) => {
    close();
    if (href === "#contact") {
      window.dispatchEvent(new CustomEvent("spaceport:open-waitlist"));
    }
  };

  return (
    <header className={`site-nav${expanded ? " is-expanded" : ""}`} aria-label="Site header">
      <div className="site-nav__top">
        <a className="brand-mark" href="#top" aria-label="Spaceport home" onClick={close}>
          <img src="/assets/SpaceportIcons/SpaceportFullLogoWhite.svg" alt="Spaceport" />
        </a>

        <nav className="site-nav__links site-nav__links--desktop" aria-label="Primary navigation">
          {links.map((link) => (
            <a href={link.href} key={link.href} onClick={() => activate(link.href)}>
              {link.label}
            </a>
          ))}
        </nav>

        <button
          className="site-nav__toggle"
          type="button"
          aria-label={expanded ? "Close navigation" : "Open navigation"}
          aria-expanded={expanded}
          onClick={() => setExpanded((value) => !value)}
        >
          <img src="/assets/SpaceportIcons/Arrow.svg" alt="" aria-hidden="true" />
        </button>
      </div>

      <nav className="site-nav__links site-nav__links--mobile" aria-label="Mobile navigation">
        {links.map((link) => (
          <a href={link.href} key={link.href} onClick={() => activate(link.href)}>
            {link.label}
          </a>
        ))}
      </nav>
    </header>
  );
}
